<template>
  <div
    :style="{
      textDecoration: 'none',
      width: '100%',
      cursor: active ? 'pointer' : 'default'
    }"
  >
    <div
      :style="{ backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff' }"
      class="quiz-block"
      style="padding-bottom: 0px; border-radius: 12px; margin-bottom: 15px !important;"
    >
      <div class="quiz-image">
        <img
          :class="[quiz_data.is_live ? '' : 'brightness']"
          :src="quiz_data.banner_url"
          alt="quiz"
          class="img-fluid"
        />
      </div>

      <div
        style="display: flex; justify-content: space-between; align-items: center;"
      >
        <div>
          <p
            :style="{
              margin: '-20px 0px 5px 0px',
              fontSize: '16px',
              color: '#000000',
              fontWeight: '500'
            }"
          >
            {{ quiz_data.name }}
          </p>
          <p style="font-size: 12px; margin: 0px !important; color: gray;">
            Win up to:
            <img
              :src="quiz_data.currency_icon_url"
              style="width: 10px; height: 10px; margin-right: 3px; margin-left: 2px;"
            />{{ quiz_data.max_reward }}
          </p>
        </div>

        <div
          style="display: flex; justify-content: center; align-items: center; flex-direction: column; padding-top: 5px; margin-bottom: 5px;"
        >
          <div
            style="font-size: 10px; font-weight: 600;"
            :class="[active ? 'quiz-end' : '', 'timer']"
          >
            <span>
              {{
                active ? "Ends In:- " + time_left : "Starts In:- " + time_left
              }}
            </span>
          </div>

          <!-- ⭐ ONLY PLAY BUTTON IS CLICKABLE ⭐ -->
          <router-link
            v-if="active"
            :to="{
              name: 'poll_details_custom',
              params: { id: quiz_data.id, title: quiz_data.name }
            }"
            style="text-decoration: none;"
          >
            <span
              :style="{
                backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
                padding: '8px',
                borderRadius: '20px',
                color: isDarkTheme ? headingTextColor : '#ffffff',
                fontSize: '12px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '5px',
                width: '100%',
                cursor: 'pointer'
              }"
            >
              {{ quiz_data.is_live ? "Play" : button_text || "Play" }}

              <PlayIcon />
            </span>
          </router-link>

          <!-- ❌ Disabled button -->
          <span
            v-else
            :style="{
              backgroundColor: '#cccccc',
              padding: '8px',
              borderRadius: '20px',
              color: '#ffffff',
              fontSize: '12px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '5px',
              width: '100%'
            }"
          >
            {{ button_text || "Play" }}
            <PlayIcon />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { globals } from "@/mixins/globals";
import PlayIcon from "./play-icon.vue";

export default {
  name: "quiz-list-card",
  mixins: [globals],
  props: {
    quiz_data: Object
  },
  components: {
    PlayIcon
  },
  data() {
    return {
      time_left: "",
      active: false,
      quiz: this.quiz_data,
      button_text: this.quiz_data.button_text
    };
  },
  methods: {
    async showTime(data) {
      let dateStr = data.is_live || this.active ? data.ends_at : data.starts_at;

      while (true) {
        const now = new Date();
        const target = new Date(dateStr);
        let diff = target - now;

        if (diff <= 0) {
          this.time_left = "00h:00m:00s";
          this.$emit("quizend");
          break;
        }

        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor(diff / (1000 * 60 * 60)) % 24;
        const m = Math.floor(diff / (1000 * 60)) % 60;
        const s = Math.floor(diff / 1000) % 60;

        this.time_left = `${d ? (d < 10 ? "0" + d : d) + "d:" : ""}${
          h < 10 ? "0" + h : h
        }h:${m < 10 ? "0" + m : m}m:${s < 10 ? "0" + s : s}s`;

        await new Promise(r => setTimeout(r, 1000));
      }
    }
  },
  created() {
    this.showTime(this.quiz);
    this.active = new Date(this.quiz.starts_at) < new Date();
  },
  mounted() {
    this.interval = setInterval(() => {
      this.active = new Date(this.quiz.starts_at) < new Date();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
    active(val) {
      if (val) {
        this.quiz_data.is_live = true;
        this.showTime(this.quiz);
      }
    }
  },
  computed: {
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme !== undefined
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return false;
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    },
    buttonBGColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null;
    },
    offersCardBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.offersCardBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null;
    },
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    }
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";

.brightness {
  filter: brightness(0.75);
  opacity: 0.65;
}
</style>
